export default __webpack_public_path__ + "static/media/uhasselt-standaard.0562641e.png";